<template>
    <p 
      class="close-button" 
      @click.prevent="$emit('click')"
    >
        ✕ 閉じる
    </p>
  </template>
  
  <script>
  export default {
    name: 'CancelModal',
  }
  </script>

  <style>
    .close-button {
        font-size: 16px;
        cursor: pointer;
        margin-top: 20px;
    }
  </style>